import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { api } from "../lib/api";
import { qk } from "./keys";
import type { Coachee, PersonFollowUp } from "./types";

/** A person's year (allocation, assignments, reports, requests): the person, their coach, the DAR. */
export function usePersonFollowUp(id: number, year: number) {
  return useQuery({
    queryKey: qk.followUp(id, year),
    queryFn: ({ signal }) => api<PersonFollowUp>(`/api/people/${id}/follow-up`, { signal, query: { year } }),
    enabled: Number.isInteger(id) && id > 0,
    staleTime: 30_000,
    // Switching years keeps the previous year on screen until the next one lands.
    placeholderData: keepPreviousData,
  });
}

/** The people I coach (Boond `hrManager`), present in Boond, with their current projects. */
export function useMyCoachees() {
  return useQuery({
    queryKey: qk.coachees,
    queryFn: ({ signal }) => api<Coachee[]>("/api/me/coachees", { signal }),
    staleTime: 60_000,
  });
}
